module.exports = __webpack_public_path__ + "assets/img/btn-view-e334fdce.png";